module.exports = __webpack_public_path__ + "img/syringe.43e17a8e.png";